import OverviewMap from './OverviewDeviceMap.vue'
OverviewMap.install = function (Vue) {
  Vue.component('deviceon-overview-map', OverviewMap)
}
export default OverviewMap
